import { isOk } from "../../result";
import { PaymentProvider } from "../../models/Tenant";
import { PaymentProviderActionTypes, REQUEST_PAYMENT_PROVIDER } from "./types";
import { getPaymentProviders } from "../../api/tenantApi";

function fetchPaymentProviders(
  paymentProviders: ReadonlyArray<PaymentProvider>
): PaymentProviderActionTypes {
  return {
    type: REQUEST_PAYMENT_PROVIDER,
    payload: paymentProviders
  };
}

export const thunkFetchPaymentProviders = () => async (dispatch: any) => {
  try {
    const result = await getPaymentProviders();
    if (isOk(result)) {
      dispatch(fetchPaymentProviders(result.value));
    }
  } catch (error) {
    console.log(error);
  }
};
